import type { TypeConversation, TypeConversationSort } from '@/types/conversation/types.conversation.email';

export function conversationOrder(sort: TypeConversationSort) {
    const direction = sort === 'oldest' ? 1 : -1;
    return (a: TypeConversation, b: TypeConversation): number => {
        const diff = new Date(a.last.at).getTime() - new Date(b.last.at).getTime();
        if (diff !== 0) return diff * direction;
        return (a.id < b.id ? -1 : a.id > b.id ? 1 : 0) * direction;
    };
}

export default conversationOrder;
